import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faCheckCircle, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import { AuthComponent } from '../auth/auth.component';

@Component({
  selector: 'app-register-rs',
  templateUrl: './register-rs.component.html',
  styleUrls: ['./register-rs.component.scss']
})
export class RegisterRsComponent implements OnInit {

  faPaperPlane = faPaperPlane;
  faCheckCircle = faCheckCircle;


  date = new Date();
  checked = false;

  confirm = false;

  constructor(
    public dialogRef: MatDialogRef<AuthComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    public uiService: UiService
  ) { }

  ngOnInit(): void { }


  // checks if the terms of use are accepted
  isCheck(): void {
    this.checked = !this.checked;
  }

  confirmToRegister(): void {
    const newUser = {
      firstName: this.data.firstName,
      lastName: this.data.lastName,
      dBirth: this.date,
      email: this.data.email,
      name: null,
      titre: null,
      monClub: null,
      password: null,
      socialId: this.data.id,
      json: JSON.stringify(this.data),
      socialType: this.data.provider
    };

    if (!this.checked) {
      this.uiService.openSnackBar('Vous devez accepter les conditions générales d\'utilisation', '');
    } else {

      this.confirm = true;
      this.userService.registerUser(newUser).subscribe(() => {

      });
    }
  }
}
